var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("c-tab", {
    attrs: {
      type: "horizon",
      dense: true,
      inlineLabel: true,
      tabItems: _vm.tabItems,
      height: _vm.tabHeight,
    },
    on: {
      "update:tabItems": function ($event) {
        _vm.tabItems = $event
      },
      "update:tab-items": function ($event) {
        _vm.tabItems = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (tab) {
          return [
            _c(tab.component, {
              tag: "component",
              attrs: {
                popupParam: _vm.popupParam,
                evalTable: _vm.evalTable,
                imprTabInfo: _vm.imprTabInfo,
                isOld: _vm.isOld,
                disabled: _vm.disabled,
                inputEditable: _vm.inputEditable,
                inputEditable2: _vm.inputEditable2,
                research: _vm.research,
                contentHeight: _vm.contentHeight,
              },
              on: {
                "update:evalTable": function ($event) {
                  _vm.evalTable = $event
                },
                "update:eval-table": function ($event) {
                  _vm.evalTable = $event
                },
                "update:imprTabInfo": function ($event) {
                  _vm.imprTabInfo = $event
                },
                "update:impr-tab-info": function ($event) {
                  _vm.imprTabInfo = $event
                },
                "update:isOld": function ($event) {
                  _vm.isOld = $event
                },
                "update:is-old": function ($event) {
                  _vm.isOld = $event
                },
                "update:disabled": function ($event) {
                  _vm.disabled = $event
                },
                "update:inputEditable": function ($event) {
                  _vm.inputEditable = $event
                },
                "update:input-editable": function ($event) {
                  _vm.inputEditable = $event
                },
                "update:inputEditable2": function ($event) {
                  _vm.inputEditable2 = $event
                },
                "update:input-editable2": function ($event) {
                  _vm.inputEditable2 = $event
                },
                "update:research": function ($event) {
                  _vm.research = $event
                },
                "update:contentHeight": function ($event) {
                  _vm.contentHeight = $event
                },
                "update:content-height": function ($event) {
                  _vm.contentHeight = $event
                },
                closePopup: _vm.closePopup,
                setRegInfo: _vm.setRegInfo,
              },
            }),
          ]
        },
      },
    ]),
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v
      },
      expression: "tab",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }